import { render, staticRenderFns } from "./PaymentMethodTable.vue?vue&type=template&id=2d910836&"
import script from "./PaymentMethodTable.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports